module.exports = __webpack_public_path__ + "assets/5cfa3f62a4a8a5ed0920e910b5cb7856.png";